module.exports = __webpack_public_path__ + "img/blackw.b4967cda.png";